import React from "react";
import { Helmet } from "react-helmet";
import CommonDiv1 from "../../shared/CommonDiv1";
import IMAGES from "../../Images";
import ThreeCards from "../../shared/ThreeCards";
import GridTextContainer from "../../shared/GridTextContainer";
import TextButtonContainer from "../../shared/TextButtonContainer";
import GridResPonsiveCards from "./components/GridResPonsiveCards";
import WhatsappDiv6 from "../../shared/WhatsappDiv6";
import { HeroContainer } from "../../assets/styles/theme/styles";
import IVRAccordion from "../../industry/pages/industry-education/components/IVRAccordion";

export default function Email() {
  const helpItems = [
    {
      title: "Targeted",
      description: `Emails can be targeted
      to specific audiences or groups of people based on their interests, behavior,
      or preferences. This can help ensure that the right message is reaching the
      right people at the right time.
      `,
      image: `${IMAGES.emailc1}`,
    },
    {
      title: "Measurable",
      description: `Email marketing
      campaigns can be tracked and measured using analytics tools, allowing you to
      see who opened your email, clicked on links, and took action as a result of
      your message. This can help you improve your campaigns over time and make
      data-driven decisions.      
      `,
      image: `${IMAGES.emailc2}`,
    },
    {
      title: "Personalized",
      description: `Emails can be
      personalized with the recipient's name or other relevant information, making
      them feel more personal and engaging. This can help build stronger
      relationships with customers or clients and increase their loyalty to your
      brand or service.      
      `,
      image: `${IMAGES.emailc3}`,
    },
  ];
  const helpContent = [
    {
      title: "Route incoming emails",
      description: "Control the flow of your incoming emails in easy to read.",
    },
    {
      title: "Send at the right time",
      description:
        "No more guessing when your recipients will open your emails, we’ll send them at the best time on your behalf based on historic open data.",
    },
    {
      title: "Manage Suppressions",
      description:
        "Automatically suppress unsubscribes, spam complaints, and hard bounces to improve your chances of hitting the inbox.",
    },
    {
      title: "Lightning fast delivery",
      description:
        "Send tens of millions of messages per hour for maximum impact, backed by our industry-leading service level agreements.",
    },
    {
      title: "Logging and Analytics",
      description:
        "Get valuable performance insights that go beyond open and click with our robust email analytics and log retention.",
    },
    {
      title: "Add an email expert",
      description:
        "Need an expert aye? We offer deliverability consulting with a technical account manager to advise in the creation and management of your email programs.",
    },
  ];

  const cards = [
    {
      body: [
        `Improve remotely based user-experience as their areas may have cellular network Issues, but with the help of data network based channels can be initiated to the mobile numbers.`,
      ],
    },
    {
      body: [
        `Priorities can be defined based on certain use-cases of clients and it can be modified using user-Interface at any given point of time.`,
      ],
    },
    {
      body: [
        `Augment the reach ability towards OTP deliveries with expanded options for users to get the OTPs in multiple modes.`,
      ],
    },
    {
      body: [
        `Gives multiple channel options to submit the OTP. Enhance the security level.`,
      ],
    },
  ];

  const data = [
    `Tubelight programmable API infrastructure
    enables developers to easily integrate communication API’s and create solutions
    of their choice. Create a free developer account today to access API and SDK’s.`,
  ];

  const paraTextBtnCon = [
    "Priorities can be set-up to initiate OTP among the most effective or useful channels based on the use-cases of an enterprise / client. Also, failovers are enabled in case of any first channel failing due to any reasons if so then the seconds, third can be aligned.",
  ];

  const AccordionData2 = [
    {
      title: `Define your goals`,
      hiddenPara: `What do you want to achieve with your email marketing campaign? Define your goals and objectives clearly to help guide your strategy and tactics.
      `,
      hiddenImg: IMAGES.emailfg2,
    },
    {
      title: `Build your subscriber list`,
      hiddenPara: `You'll need a list of people to send your emails to. Build your subscriber list by offering incentives for sign-ups, such as exclusive content, discounts, or freebies.
      `,
      hiddenImg: IMAGES.emailfg2,
    },

    {
      title: `Create your email content`,
      hiddenPara: `Your emails should be engaging, informative, and relevant to your audience. Use attention-grabbing subject lines, personalized greetings, and clear calls to action to encourage opens, clicks, and conversions.
      `,
      hiddenImg: IMAGES.emailfg2,
    },
    {
      title: `Design your emails`,
      hiddenPara: `Use a consistent design and layout for your emails that aligns with your brand identity. Use images, colors, and typography to make your emails visually appealing and easy to read.
      `,
      hiddenImg: IMAGES.emailfg2,
    },
    {
      title: `Test and optimize`,
      hiddenPara: `Test different elements of your emails, such as subject lines, content, and design, to see what works best. Use data and analytics to optimize your campaigns over time and improve your results.
      `,
      hiddenImg: IMAGES.emailfg2,
    },
    {
      title: `Monitor and measure`,
      hiddenPara: `Monitor your email campaign's performance using metrics such as open rates, click-through rates, and conversions. Use this data to refine your approach and improve your future campaigns.
      `,
      hiddenImg: IMAGES.emailfg2,
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Send Targeted Emails at Scale using API Services|Tubelight
        </title>
        <meta
          name="description"
          content="Leverage Email API Services & AI Chatbots for Streamlined Communication - Automate your email marketing and customer interactions with Tubelight."
        />
        <meta
          name="keywords"
          content="email api services, ai chat bot services"
        ></meta>
      </Helmet>

      <HeroContainer imageUrl={IMAGES.smsbgdiv1} ht="1200px" bgSize="cover">
        <CommonDiv1
          title={"Send Email with reliable inbox delivery."}
          description={`Deliver Best in Class Email Experiences`}
          fgvideo={IMAGES.emailfg1video}
          fgimage={IMAGES.emailfg1}
          btns={["Try for Free", "Talk to Expert"]}
          video
        />

        <ThreeCards
          title="For business, email is professional"
          titleDes={`Emails can be sent and received almost instantly, making
          them a very efficient way to communicate with others, professionally.`}
          subtitle="Targeted"
          description="Emails can be targeted
          to specific audiences or groups of people based on their interests, behavior,
          or preferences. This can help ensure that the right message is reaching the
          right people at the right time."
          helpItems={helpItems}
        />
      </HeroContainer>

      <HeroContainer imageUrl={IMAGES.bg4}>
        <IVRAccordion
          AccordionData={AccordionData2}
          defaultImg={IMAGES.emailfg2}
          mainheading={`Email marketing campaign strategy`}
          pd={`5px 0px`}
        />
        <GridTextContainer
          heading="Everything you're looking for in an enterprise Email API"
          helpContent={helpContent}
        />
      </HeroContainer>

      <HeroContainer imageUrl={IMAGES.bg1}>
        <TextButtonContainer
          heading="Integrate Email with MuCh for 2FA."
          para={paraTextBtnCon}
          btn={["Learn More", "Talk To Expert"]}
        />
        <GridResPonsiveCards heading={`Features`} cards={cards} />
      </HeroContainer>

      <HeroContainer imageUrl={IMAGES.bg4}>
        <WhatsappDiv6
          heading={`For
            Developers, By Developers`}
          data={data}
        />
      </HeroContainer>
    </>
  );
}
